import React, { Component } from "react";
import axios from "axios";
import { Spin, Result, Button, Segmented } from "antd5";
import { DownloadOutlined, PrinterOutlined, EyeOutlined, FilePdfOutlined } from "@ant-design/icons";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import ordenServicioCMMSPdf from "../../Pdf/cmms/ordenServicioCMMSPdf";
import reporteVisitaCMMSPdf, { textosReporteVisita } from "../../Pdf/cmms/reporteVisitaCMMSPdf";
import etiquetaActivoCMMSPdf from "../../Pdf/cmms/etiquetaActivoCMMSPdf";
import certificadoCMMSPdf from "../../Pdf/cmms/certificadoCMMSPdf";
import { medirMarcaAgua } from "../../Pdf/cmms/comunCMMSPdf";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

// Pagina PUBLICA que abre la app del CMMS para descargar o imprimir un documento desde el celular
// (/activoCMMS/documento/<token>, enlace temporal que firma la app). Arma el PDF aqui, en el
// navegador, con los MISMOS armadores que el web, asi sale identico al que se descarga en la oficina.

const NOMBRES = { orden: "Orden de Servicio", visita: "Reporte de visita", etiqueta: "Etiqueta del equipo", certificado: "Certificado" };
const urlActivo = (token) => `${window.location.origin}/activoCMMS/${token}`;
const esAndroid = () => /Android/i.test(navigator.userAgent || "");

const estilos = {
    pagina: { minHeight: "100vh", background: "#eef2f5", padding: "16px 12px 40px", fontFamily: "'Segoe UI', Calibri, Arial, sans-serif" },
    contenedor: { maxWidth: 720, margin: "0 auto" },
    tarjeta: { background: "#fff", borderRadius: 12, boxShadow: "0 2px 10px rgba(31,42,55,.08)", padding: 16, marginBottom: 12 },
    botones: { display: "flex", gap: 8, flexWrap: "wrap", marginTop: 12 },
    ayuda: { fontSize: 12, color: "#7a8794", marginTop: 10 },
};

class DocumentoPublicoCMMS extends Component {
    state = { cargando: true, generando: false, error: null, tipo: null, respuesta: null, formato: "etiqueta", url: null };
    pdf = null;

    componentDidMount() {
        this.consultar();
    }

    componentWillUnmount() {
        if (this.state.url) URL.revokeObjectURL(this.state.url);
    }

    consultar = async () => {
        try {
            const res = await axios.post("cmmsPublico/documentoCMMS", { token: this.props.token });
            if (res.data.success !== 2) return this.setState({ cargando: false, error: res.data.message || "No se pudo abrir el documento" });
            this.setState({ cargando: false, tipo: res.data.tipo, respuesta: res.data }, this.generar);
        } catch (error) {
            this.setState({ cargando: false, error: "No se pudo consultar el documento. Revise su conexión." });
        }
    };

    // docDefinition, igual que en el web (Servicio.js, ModalReporteVisitaCMMS, ModalEtiquetasCMMS, pdfCertificado).
    armar = async () => {
        const { tipo, respuesta, formato } = this.state;
        if (tipo === "orden") return ordenServicioCMMSPdf(await medirMarcaAgua(respuesta.datos));
        if (tipo === "certificado") return certificadoCMMSPdf(await medirMarcaAgua(respuesta.datos));
        if (tipo === "visita") {
            const datos = await medirMarcaAgua(respuesta.datos);
            return reporteVisitaCMMSPdf(datos, textosReporteVisita(datos));
        }
        return etiquetaActivoCMMSPdf(respuesta, { formato, urlActivo });
    };

    generar = async () => {
        this.setState({ generando: true });
        try {
            this.pdf = pdfMake.createPdf(await this.armar());
            this.pdf.getBlob((blob) => {
                if (this.state.url) URL.revokeObjectURL(this.state.url);
                this.setState({ url: URL.createObjectURL(blob), generando: false });
            });
        } catch (error) {
            console.log(error);
            this.setState({ generando: false, error: "No se pudo generar el PDF" });
        }
    };

    get folio() {
        const { tipo, respuesta } = this.state;
        const d = respuesta?.datos || {};
        if (tipo === "orden") return d.servicio?.folioExterno || d.servicio?.codigo || "";
        if (tipo === "certificado") return d.certificado?.codigo || "";
        if (tipo === "visita") return d.folio || "";
        return "";
    }

    get nombreArchivo() {
        return `${(NOMBRES[this.state.tipo] || "Documento").replace(/\s+/g, "_")}${this.folio ? `_${this.folio}` : ""}.pdf`;
    }

    render() {
        const { cargando, generando, error, tipo, url } = this.state;
        if (cargando)
            return (
                <div style={{ ...estilos.pagina, display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <Spin size="large" />
                </div>
            );
        if (error)
            return (
                <div style={estilos.pagina}>
                    <div style={estilos.contenedor}>
                        <div style={estilos.tarjeta}>
                            <Result status="warning" title="No se pudo abrir el documento" subTitle={error} />
                        </div>
                    </div>
                </div>
            );
        return (
            <div style={estilos.pagina}>
                <div style={estilos.contenedor}>
                    <div style={estilos.tarjeta}>
                        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                            <FilePdfOutlined style={{ fontSize: 28, color: "#d64545" }} />
                            <div>
                                <div style={{ fontSize: 18, fontWeight: 600, color: "#1f2a37" }}>{NOMBRES[tipo] || "Documento"}</div>
                                {this.folio ? <div style={{ fontSize: 13, color: "#7a8794" }}>{this.folio}</div> : null}
                            </div>
                        </div>
                        {tipo === "etiqueta" && (
                            <div style={{ marginTop: 12 }}>
                                <Segmented
                                    value={this.state.formato}
                                    options={[
                                        { label: "Impresora de etiquetas", value: "etiqueta" },
                                        { label: "Hoja carta", value: "carta" },
                                    ]}
                                    onChange={(formato) => this.setState({ formato }, this.generar)}
                                />
                            </div>
                        )}
                        <div style={estilos.botones}>
                            <Button type="primary" size="large" icon={<EyeOutlined />} loading={generando} disabled={!url} onClick={() => (window.location.href = url)}>
                                Ver PDF
                            </Button>
                            <Button size="large" icon={<DownloadOutlined />} disabled={!url} onClick={() => this.pdf?.download(this.nombreArchivo)}>
                                Descargar
                            </Button>
                            <Button size="large" icon={<PrinterOutlined />} disabled={!url} onClick={() => this.pdf?.print()}>
                                Imprimir
                            </Button>
                        </div>
                        <div style={estilos.ayuda}>
                            Para imprimir o mandarlo desde el celular: “Ver PDF” y después el botón Compartir del visor (Imprimir, WhatsApp, correo, Guardar en archivos). El enlace
                            dura 30 minutos.
                        </div>
                    </div>
                    {/* Vista previa (Android no muestra PDF dentro de la pagina: ahi se usa "Ver PDF"). */}
                    {url && !esAndroid() ? (
                        <div style={{ ...estilos.tarjeta, padding: 0, overflow: "hidden" }}>
                            <iframe title="Vista previa" src={url} style={{ width: "100%", height: "75vh", border: 0, background: "#f4f6f9" }} />
                        </div>
                    ) : null}
                </div>
            </div>
        );
    }
}

export default DocumentoPublicoCMMS;
